import { useAuth } from "./useAuth";
import { BasicUserType } from "@/types/user";

interface UseUserReturn {
  user: BasicUserType | null;
  isLoading: boolean;
}

const useUser = (isLogin: boolean = false): UseUserReturn => {
  const { user, loading } = useAuth();

  // Convert the useAuth user to BasicUserType format with proper UUID strings
  const basicUser: BasicUserType | null = user ? {
    id: user.id, // Now properly using string UUID
    name: user.name || '',
    username: user.username || '',
    email: user.email,
    emailVerified: null,
    image: user.image || null,
    hashedPassword: '', // Not available from useAuth
    bio: '', // Not available from useAuth
    bioLink: null, // Not available from useAuth
    profileURL: null, // Not available from useAuth
    followers: [], // Not available from useAuth
    following: [], // Not available from useAuth
    createdAt: new Date(), // Not available from useAuth
    updatedAt: new Date(), // Not available from useAuth
    emailVerificationToken: null,
    emailVerificationTokenExpiry: null,
    passwordResetToken: null,
    passwordResetTokenExpiry: null,
    suspended: false
  } : null;

  return {
    user: basicUser,
    isLoading: loading
  };
};

export default useUser;
